// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stripe_token: 'STRIPE_TOKEN',
  paypal_token: 'PAYPAL_TOKEN',
  // API_SECURITY: 'http://216.238.93.205:3000/api',
  // API remota + socket por proxy (mismo JWT / mismo cluster):
  API_SECURITY: 'https://kashpos.ddns.net/api',


  monitoreoSocketUseDevProxy: false,

  socketIoPath: '/api/socket.io',

 

};


